import NewPasswordPage from './NewPasswordPage';

export default NewPasswordPage;
